import React from 'react';
import { Tag } from 'antd';
import {
  createColumnTag,
  createColumnText,
  renderWithDetail,
  widthOptions,
} from '../../../components/table/function/createColumn';
import { CLAIM_STATUS, PROCESS_STATUS } from '../../../resources/status';
import { color } from '../../../resources';
import { ClaimCountIcon } from './claimCountIcon';
import { getSendCsLabel, SEND_CS_LABEL } from './sendCsStatus';

// คอลัมน์ข้อมูลเคลมที่หน้าเคลมสินค้ากับหน้าอนุมัติใช้ร่วมกัน
// ไม่ส่ง handler มา = แสดงอย่างเดียว กดแก้ไม่ได้

export const createClaimStatusColumns = ({ onModalProcessStatus } = {}) => {
  const claimStatusColumn = createColumnTag(
    'สถานะ',
    { key: 'claimStatus', text: 'claimStatusName', icon: true },
    CLAIM_STATUS,
  );
  const processStatusColumn = createColumnTag(
    'สถานะภายใน',
    { key: 'processStatus', text: 'processStatusName' },
    PROCESS_STATUS,
    {
      render: (_, record) => {
        const status = PROCESS_STATUS?.find((s) => s.key === record?.processStatus);
        const tag = <Tag color={status?.color}>{status?.label}</Tag>;
        if (!onModalProcessStatus) return tag;
        // สต็อกไม่ล็อกการเปลี่ยนสถานะ ของไม่พอก็ยังกดเปลี่ยนได้
        return (
          <div style={{ cursor: 'pointer' }} onClick={() => onModalProcessStatus(record)}>
            {tag}
          </div>
        );
      },
      filters: PROCESS_STATUS?.map((status) => ({
        text: status?.label,
        value: status?.key,
      })),
      onFilter: (value, record) => record?.processStatus === value,
    },
  );
  return { claimStatusColumn, processStatusColumn };
};

export const claimInfoColumns = ({ onModalChangeTrackNumber, onShowHistory } = {}) => [
  createColumnText(
    'เลขที่เคลม',
    'claimCode',
    widthOptions(190, {
      onFilter: (value, record) =>
        [record.claimCode, record.claimDate].some((item) =>
          item?.toString().toLowerCase().includes(value.toLowerCase()),
        ),
      render: (text, record) => renderWithDetail(text, `วันที่แจ้ง: ${record.claimDate || '-'}`),
    }),
  ),
  createColumnText('รหัสสินค้า', 'itemCode', widthOptions(140)),
  createColumnText('ชื่อสินค้า', 'productName', widthOptions(190)),
  createColumnText(
    'เลขที่ลงทะเบียน',
    'warrantyCode',
    widthOptions(190, {
      onFilter: (value, record) =>
        [record.warrantyCode, record.warrantyDate].some((item) =>
          item?.toString().toLowerCase().includes(value.toLowerCase()),
        ),
      render: (text, record) =>
        renderWithDetail(
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            <ClaimCountIcon
              warrantyClaimCount={record.warrantyClaimCount}
              onClick={onShowHistory ? () => onShowHistory(record) : undefined}
            />
            {text}
          </span>,
          `วันที่ลงทะเบียน: ${record.warrantyDate || '-'}`,
        ),
    }),
  ),
  createColumnText(
    'ชื่อ-นามสกุล',
    'fullName',
    widthOptions(240, {
      onFilter: (value, record) =>
        [record.fullName, record.telephone, record.lineName].some((item) =>
          item?.toString().toLowerCase().includes(value.toLowerCase()),
        ),
      render: (text, record) =>
        renderWithDetail(
          text,
          [record.telephone, record.lineName && `LINE: ${record.lineName}`]
            .filter(Boolean)
            .join(' · ') || '-',
        ),
    }),
  ),
  createColumnText(
    'เลขพัสดุ',
    'trackingNumber',
    widthOptions(200, {
      onFilter: (value, record) =>
        [record.trackingNumber, record.shippingDate].some((item) =>
          item?.toString().toLowerCase().includes(value.toLowerCase()),
        ),
      render: (text, record) => {
        const tag = <Tag color={color.orangeTheme}>{text}</Tag>;
        return renderWithDetail(
          record.trackingNumber ? (
            onModalChangeTrackNumber ? (
              <div style={{ cursor: 'pointer' }} onClick={() => onModalChangeTrackNumber(record)}>
                {tag}
              </div>
            ) : (
              tag
            )
          ) : null,
          `วันที่จัดส่ง: ${record.shippingDate || '-'}`,
        );
      },
    }),
  ),
  createColumnText('รุ่นมือถือ', 'mobileModelName', widthOptions(130)),
  createColumnText('หมายเหตุ', 'remark', widthOptions(140)),
  // ป้ายคำนวณเองจาก sendCsStatus (ไม่ใช้ sendCsStatusLabel จาก API ที่ไม่รู้จัก SUCCESS)
  // จึงกรองด้วยตัวเลือกสถานะแทนช่องค้นหาข้อความ
  createColumnText('ส่ง CS', 'sendCsStatusLabel', {
    noSearch: true,
    sorter: (a, b) => getSendCsLabel(a).localeCompare(getSendCsLabel(b)),
    others: {
      width: 180,
      filters: Object.values(SEND_CS_LABEL).map((label) => ({ text: label, value: label })),
      onFilter: (value, record) => getSendCsLabel(record) === value,
      render: (text, record) =>
        renderWithDetail(
          getSendCsLabel(record),
          `CS: ${record.refCsId || '-'} / Journal: ${record.refJournalId || '-'}`,
        ),
    },
  }),
];
